import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAppCostCenterAllocation } from '../../components/upeosoft/ModalApp/ModalApp';
import {
  cancleCostCenterAllocation,
  deleteCostCenterAllocation,
  getCostCenterAllocation,
  submitCostCenterAllocation,
} from '../../network/CostCenterAllocation';
import StatusTag from '../../hooks/StatusHook';
import { TiCancel } from 'react-icons/ti';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const CostCenterAllocation = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteCostCenterAllocation(id),
    // mutationFn: (id) => cancleCostCenterAllocation(id),
    // mutationFn: (id) => submitCostCenterAllocation(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getCostCenterAllocation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitCostCenterAllocation(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getCostCenterAllocation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancleCostCenterAllocation(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getCostCenterAllocation],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });

  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCostCenterAllocation],
    queryFn: () => getCostCenterAllocation(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.Bank,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setOpen(true);
        setEdit(true);
      },
    },
    {
      key: '2',
      label: t.submit + ' ' + t.Bank,
      icon: <MdSubtitles />,
      onClick: () => {
        handleSubmit.mutate(record?.name);
      },
      disabled: record?.docstatus !== 0,
    },
    {
      key: '3',
      label: t.cancel + ' ' + t.Bank,
      icon: <TiCancel />,
      onClick: () => {
        handleCancle.mutate(record?.name);
      },
      disabled: record?.docstatus !== 1,
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.Bank}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.company,
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: t.MainCostCenter,
      dataIndex: 'main_cost_center',
      key: 'main_cost_center',
    },
    {
      title: t.ValidFrom,
      dataIndex: 'valid_from',
      key: 'valid_from',
    },
    {
      title: t.status,
      dataIndex: 'docstatus',
      key: 'docstatus',
      render: (text, record) => <StatusTag status={record?.docstatus} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary"
               icon={<MdModeEditOutline />}
              />
            </Popover>
            {
            record?.docstatus === 0 &&
            <Popover
              placement="top"
              title={t.submit}
              onClick={() => {
                handleSubmit.mutate(record?.name);
              }}
            >
              <Button size="small" type="primary"
              style={{ backgroundColor: '#28a745' }}
               icon={<MdSubtitles  />}
              />
            </Popover>
            }
            {
            record?.docstatus === 1 &&
            <Popover
              placement="top"
              title={t.Cancel}
              onClick={() => {
                handleCancle.mutate(record?.name);
              }}
            >
              <Button size="small" type="primary"
              style={{ backgroundColor: '#ff4d4f' }}
               icon={<TiCancel />}
              />
            </Popover>
            }
            <Popconfirm
              title={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger
               icon={<MdDelete />}
              />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Finance} subTitle="Bank" path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddCostCenterAllocation}
            </Button>
          }
        />
      </div>
      <ModalAppCostCenterAllocation
        open={open}
        setOpen={setOpen}
        setEditId={setEditId}
        setEdit={setEdit}
        edit={edit}
        editId={editId}
        t={t}
      />
    </div>
  );
};

export default CostCenterAllocation;
